/** Safe repair outcomes shared by queue, persistence and presentation boundaries. */
export const CATALOG_REPAIR_OUTCOMES = {
  INCOMPLETE: "CATALOG_REPAIR_INCOMPLETE",
  UNCONFIRMED: "CATALOG_REPAIR_UNCONFIRMED",
} as const;

export const CATALOG_REPAIR_JOB_TYPE = "CATALOG_REPAIR" as const;

export const CATALOG_REPAIR_AUDIT_ACTIONS = {
  REQUESTED: "CATALOG_REPAIR_REQUESTED",
  COMPLETED: "CATALOG_REPAIR_COMPLETED",
} as const;

export const CATALOG_REPAIR_MESSAGES = {
  INCOMPLETE:
    "Some catalog facts may already have updated. Review this product before another repair.",
} as const;
